(() => {
  const storageKey = 'earthlayers-newsletter-section';
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form[data-el-newsletter]')) return;
    try { sessionStorage.setItem(storageKey, form.dataset.elNewsletter); } catch (error) { /* Storage can be disabled. */ }
  });

  function openDiscount() {
    const dialogs = Array.from(document.querySelectorAll('dialog[data-el-newsletter-discount]'));
    if (!dialogs.length) return;
    let sectionId;
    try { sectionId = sessionStorage.getItem(storageKey); } catch (error) { /* Use the first successful form. */ }
    const dialog = dialogs.find((item) => item.dataset.sectionId === sectionId) || dialogs[0];
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const previousOverflow = document.body.style.overflow;
    dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; });
    dialog.querySelector('[data-discount-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.querySelector('[data-discount-copy]').addEventListener('click', async () => {
      const code = dialog.querySelector('[data-discount-code]');
      const status = dialog.querySelector('[data-discount-status]');
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code.textContent.trim());
        } else {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(code);
          selection.removeAllRanges();
          selection.addRange(range);
          if (!document.execCommand('copy')) throw new Error('Copy unavailable');
          selection.removeAllRanges();
        }
        status.textContent = 'Copied';
      } catch (error) {
        const range = document.createRange();
        range.selectNodeContents(code);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        status.textContent = 'Select and copy your code.';
      }
    });
    // Liquid only renders this dialog after Shopify confirms the form succeeded.
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openDiscount, { once: true });
  else openDiscount();
})();
